"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trapBrowserFocusToElement = void 0;
var trapBrowserFocusToElement = function trapBrowserFocusToElement(event, element) {
  if (event.key !== 'Tab') return;
  var focusableInnerElements = element.querySelectorAll('a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
  if (!focusableInnerElements.length) return;
  var firstElement = focusableInnerElements[0];
  var lastElement = focusableInnerElements[focusableInnerElements.length - 1];

  // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
  if (!event.shiftKey && document.activeElement === lastElement) {
    firstElement.focus();
    event.preventDefault();
  }

  // if going backward by pressing shift+tab and firstElement is active, shift focus to last focusable element
  if (event.shiftKey && document.activeElement === firstElement) {
    lastElement.focus();
    event.preventDefault();
  }
};
exports.trapBrowserFocusToElement = trapBrowserFocusToElement;